<!-- 予約変更 -->
<template>
  <TemplateMfittMyTicketChange />
</template>

<script>
import TemplateMfittMyTicketChange from "@/views/Templates/MFITT/TemplateMfittMyTicketChange";

import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "MfittMyTicketChange",
  components: {
    TemplateMfittMyTicketChange,
  },
  setup() {},
};
</script>
